module.exports = __webpack_public_path__ + "img/5.3c8f8cf9.png";